import { render, staticRenderFns } from "./chooseBatch.vue?vue&type=template&id=b54004b0&"
import script from "@viewJs/reservation/chooseBatch.js?vue&type=script&lang=js&"
export * from "@viewJs/reservation/chooseBatch.js?vue&type=script&lang=js&"
import style0 from "./chooseBatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports